import { useCommonStore, useUserStore } from "@/stores";
import styles from "./index.module.scss";
import clsx from "clsx";
import { GenerateSvg, GeneratingSvg } from "@/assets/icons";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  SCENE_ID,
  LocalStorageKey,
  PROJECT_TYPE,
  FTSwapAnalyzeObj,
} from "@/constants";
import { credits_png } from "@/assets/images";
import FTAnalytic from "@/analyze/FTAnalytic";
import { FeatureType, GeneratVideoType, PageType, TVideoParams } from "@/stores/useCommonStore";
import EventHub from "@/utils/event";
import { GlobalEvent } from "@/constants/event";
import Analyse from "@/utils/analyse";
import RcToolTip from "../RcTooltip";

interface GenerateButtonProps {
  className?: string;
  colorType?: "green" | "purple" | "white";
  text?: string;
  showFree?: boolean;
  hidenCredit?: boolean;
  showcreditTips?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

const GenerateButton = (props: GenerateButtonProps) => {
  const {
    className,
    colorType,
    text,
    showFree,
    hidenCredit,
    showcreditTips,
    disabled,
    onClick,
  } = props;
  const { t } = useTranslation();
  const featureType = useCommonStore((state) => state.featureType);
  const generating = useCommonStore((state) => state.generating);
  const creditConsume = useCommonStore((state) => state.getters.creditConsume);
  const disabledGenerate = useCommonStore((state) => state.getters.disabledGenerate);
  const isLogin = useUserStore((state) => state.getters.isLogin);
  const mutiLoading = useCommonStore((state) => state.mutiLoading);

  // // 主动禁止优先级最高
  // if (disabled && generating) {
  //   generating = false;
  //   disabledGenerate = true;
  // }

  const handleClick = async () => {
    onClick?.();
    Analyse.getInstance().clickUpGenerate("start");
    useCommonStore.getState().startGenerate();
  };


  const creditsContent = (
    <span className={styles["credits_wrapper"]}>
      <img className={styles["credits_img"]} src={credits_png} alt="" />
      <span className={styles["credits"]}>{creditConsume}</span>
    </span>
  );

  return (
    <button
      className={clsx(
        styles["generate_button"],
        className,
        colorType && styles[colorType],
      )}
      disabled={disabledGenerate || mutiLoading || disabled}
      onClick={handleClick}
    >
      {(generating && !disabled) ? (
        <GeneratingSvg className={styles.generating_svg}></GeneratingSvg>
      ) : (
        <GenerateSvg></GenerateSvg>
      )}

      <span className={styles["text"]}>
        {(generating && !disabled) ? t("generating") : text ? t(text) : t("generate_btn")}
      </span>

      {showFree && (
        <span className={clsx(styles.free_tips)}>{t("generate_btn_free")}</span>
      )}

      {creditConsume > 0 && !showFree && !hidenCredit && !disabledGenerate && isLogin && !generating && (
        // {true && (
        showcreditTips
          ? <RcToolTip
            overlay={<>
              <span dangerouslySetInnerHTML={{__html: t("center_video_creadit_tips")}}></span>
              {/* <a target="_blank" href="">{t("center_video_creadit_tips_link")}</a> */}
            </>}
            classNames={{ body: styles.creadit_tips }}
          >
            {creditsContent}
          </RcToolTip>
          : creditsContent
      )}
    </button >
  );
};

export default GenerateButton;
